import React from "react"
import ScrollLock from "react-scrolllock"
import RawModal from "./raw/raw-modal.component"
import BoxModal from "./box/box-modal.component"
import Portal from "../../../components/common/portal/portal.component"
import { ModalProps } from "./modal.interface"
import MessageModal from "./message/message-modal.component"
import { Background } from "./modal.styled"
import { AppFunctionComponent } from "../../../types"
import Popup, { PopupProps } from "./popup/popup.component"

export enum ModalType {
  Raw = "raw",
  Box = "box",
  Message = "message",
  CustomPopup = "custom popup",
}

interface Props extends ModalProps {
  modalType: ModalType
  popupProps?: PopupProps
}

const ModalResolver: AppFunctionComponent<Props> = ({
  modalType,
  popupProps,
  ...props
}) => {
  switch (modalType) {
    case ModalType.Raw:
      return <RawModal {...props} />
    case ModalType.Box:
      return <BoxModal {...props} />
    case ModalType.Message:
      return <MessageModal {...props} />
    case ModalType.CustomPopup:
      return <Popup {...popupProps} {...props} />
  }
}

const Modal: AppFunctionComponent<Props> = ({ className, ...props }) => {
  const { active, headerVisible } = props
  return (
    <Portal>
      <ScrollLock isActive={active}>
        <Background
          active={active}
          className={className}
          data-testid="modal-background"
          headerVisible={headerVisible}
        >
          <ModalResolver {...props} />
        </Background>
      </ScrollLock>
    </Portal>
  )
}

export default Modal
